import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { useFormik } from 'formik';

const GeneralInfo = ({ profileInfo }) => {
    const [loadingBtn, setLoadingBtn] = useState(false);


    const formik = useFormik({
        initialValues: {
            id: '',
            name: '',
            email: '',
            phone: '',
            status: '',
            roleId: '',
            password: ''
        }
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                {' '}
                <div className="col-12 md:col-4">
                    <div className="field mb-3">
                        <label htmlFor="name">Partner ID</label>
                        <InputText id="name" name="name" value={profileInfo?.id} maxLength={30} disabled />
                        {formik.touched.name && formik.errors.name && <small className="p-error">{formik.errors.name}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-4">
                    <div className="field mb-3">
                        <label htmlFor="name">POC Name</label>
                        <InputText id="name" name="name" value={profileInfo?.pocName} maxLength={30} disabled />
                        {formik.touched.name && formik.errors.name && <small className="p-error">{formik.errors.name}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-4">
                    <div className="field mb-3">
                        <label htmlFor="name">POC Email</label>
                        <InputText id="name" name="name" value={profileInfo?.pocEmail} maxLength={30} disabled />
                        {formik.touched.name && formik.errors.name && <small className="p-error">{formik.errors.name}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-4">
                    <div className="field mb-3">
                        <label htmlFor="email">Status</label>
                        <InputText id="email" name="email" placeholder="Status" value={profileInfo?.status} maxLength={30} disabled />
                        {formik.touched.email && formik.errors.email && <small className="p-error">{formik.errors.email}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-4">
                    <div className="field mb-3">
                        <label htmlFor="name">Created On</label>
                        <InputText id="name" name="name" placeholder="Registered On" value={formik?.values?.name} maxLength={30} disabled />
                        {formik.touched.name && formik.errors.name && <small className="p-error">{formik.errors.name}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-4">
                    <div className="field mb-3">
                        <label htmlFor="email">Approved On</label>
                        <InputText id="email" name="email" placeholder="Created On" value={formik?.values?.email} maxLength={30} disabled />
                        {formik.touched.email && formik.errors.email && <small className="p-error">{formik.errors.email}</small>}
                    </div>
                </div>
            </div>
        </form>
    );
};

export default GeneralInfo;
